import { InformationCircleIcon } from '@interstate/components/Icons/InformationCircleIcon';
import { Tooltip } from '@interstate/components/Tooltip';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import type { TradeInIntelligenceRange as Range } from '@makemydeal/dr-dash-types';

import { DealPulseEmphasisStyle, DealPulseInlineIconStyle } from './DealPulseRow.style';

type TradeInIntelligenceRangeProps = {
    range: Range;
    enteredInputs?: string | null;
};

const TradeInIntelligenceRange = ({ range, enteredInputs }: TradeInIntelligenceRangeProps) => {
    const theme = useInterstateTheme();

    return (
        <>
            <span data-testid="trade-in-intelligence-range">
                {range.low}-
                <DealPulseEmphasisStyle data-testid="trade-in-intelligence-likely">{range.likely}</DealPulseEmphasisStyle>-
                {range.high}
            </span>
            {enteredInputs && (
                <DealPulseInlineIconStyle>
                    <Tooltip
                        position="top"
                        toolTipContent={enteredInputs}
                        size="small"
                        enterTouchDelay={0}
                        data-testid="trade-in-intelligence-entered-inputs-tooltip"
                    >
                        <InformationCircleIcon
                            color={theme.tokens.BaseColorBlue500}
                            width={14}
                            height={14}
                            tabIndex={0}
                            role="button"
                            aria-label={enteredInputs}
                            data-testid="trade-in-intelligence-entered-inputs-icon"
                        />
                    </Tooltip>
                </DealPulseInlineIconStyle>
            )}
        </>
    );
};

export default TradeInIntelligenceRange;
